<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Vendor" subTitle="Forms" />

    <CreateVendor />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateVendor from "@/components/Pages/Master/Vendor/CreateVendor.vue";

export default defineComponent({
  name: "CreateVendorPage",
  components: {
    PageTitle,
    CreateVendor,
  },
});
</script>
